var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Link, Stack } from '@mui/material';
import { get } from 'lodash';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StatusPermission } from '../../../enum';
import { Autocomplete, FormErrorText, getLOBName, getUnassignedLOB, sortByLOBName } from '../../common';
import { useFormlessContext } from '../../hooks/useFormlessContext';
import { BasePanel } from '../common/basePanel';
import { QueuePanel } from '../common/queuePanel';
import { StepContainer, StepPanel } from '../common/stepContainer';
import { WizardStep } from '../constants';
import { WizardContext } from '../context';
import { useQueueAPI, useQueuesAPI, useRefreshQueueData } from '../queue/selectors';
import { QueueStatusType } from '../queue/types';
import { useEffectiveCapacityPermission, useEffectiveQueueLocations, useIsPlanLocked, usePlanType, useWizardParams, } from '../selectors';
import { AddShrinkageFactor } from './addShrinkageFactor';
import { useClearShrinkageAPI, useCopyShrinkageAPI } from './selectors';
import { ShrinkageCopyFrom } from './shrinkageCopyFrom';
import { ShrinkageTable } from './table';
import { ShrinkageUnitMode, useShrinkageStaffSettings } from './useShrinkageUnit';
export var ShrinkageContent = function (props) {
    var _a, _b, _c, _d;
    var t = useTranslation('wizard', { keyPrefix: 'shrinkage' }).t;
    var planType = usePlanType();
    var step = useWizardParams().step;
    var addColumns = step === WizardStep.Review ? ['Average'] : [];
    var methods = useFormlessContext();
    var errors = useFormState({ name: 'shrinkages', control: methods === null || methods === void 0 ? void 0 : methods.control }).errors;
    var error = get(errors, 'shrinkages');
    var _e = useState(ShrinkageUnitMode.Percent), localUnitMode = _e[0], setLocalUnitMode = _e[1];
    var unitMode = (_a = props.unitMode) !== null && _a !== void 0 ? _a : localUnitMode;
    var setUnitMode = (_b = props.setUnitMode) !== null && _b !== void 0 ? _b : setLocalUnitMode;
    var staffSettings = useShrinkageStaffSettings(props.queueLocationId);
    var isUnitModeEnabled = ((_c = staffSettings.paidHoursPerDay) !== null && _c !== void 0 ? _c : 0) > 0 && ((_d = staffSettings.workingDaysPerWeek) !== null && _d !== void 0 ? _d : 0) > 0;
    useEffect(function () {
        if (!isUnitModeEnabled && unitMode !== ShrinkageUnitMode.Percent) {
            setUnitMode(ShrinkageUnitMode.Percent);
        }
    }, [isUnitModeEnabled, setUnitMode, unitMode]);
    return (_jsxs(Stack, __assign({ spacing: 2 }, { children: [_jsx(ShrinkageTable, __assign({}, props, { addColumns: addColumns, unitMode: unitMode, setUnitMode: setUnitMode, isUnitModeEnabled: isUnitModeEnabled })), !!(error === null || error === void 0 ? void 0 : error.root) && _jsx(FormErrorText, { message: t('overError', { planType: planType }) })] })));
};
export var ShrinkageLocationSelector = function (_a) {
    var selectedQueueLocationId = _a.selectedQueueLocationId, setSelectedQueueLocationId = _a.setSelectedQueueLocationId;
    var t = useTranslation('wizard').t;
    var _b = useContext(WizardContext), handleSaveWithoutValidation = _b.handleSaveWithoutValidation, isDirty = _b.methods.formState.isDirty;
    var queueLocations = useEffectiveQueueLocations();
    var locationOptions = useMemo(function () {
        return queueLocations.map(function (ql) { return ({
            id: ql.id,
            name: ql.planLocation.locationName,
        }); });
    }, [queueLocations]);
    return (_jsx(Autocomplete, { options: locationOptions, getOptionValue: function (o) { return o.id; }, value: selectedQueueLocationId, onChange: function (id) { return __awaiter(void 0, void 0, void 0, function () {
            var nextId;
            return __generator(this, function (_a) {
                nextId = id ? Number(id) : null;
                if (isDirty) {
                    handleSaveWithoutValidation();
                }
                setSelectedQueueLocationId(nextId);
                return [2 /*return*/];
            });
        }); }, placeholder: t('shrinkage.selectLocation'), blurOnSelect: true, "data-testid": "shrinkageLocationSelect", sx: { minWidth: '16rem' }, rumEntity: "queueLocation" }));
};
export var ShrinkageStep = function () {
    var _a, _b;
    var _c = useContext(WizardContext), handleSaveWithoutValidation = _c.handleSaveWithoutValidation, _d = _c.methods, trigger = _d.trigger, isDirty = _d.formState.isDirty;
    var refreshData = useRefreshQueueData();
    var _e = useCopyShrinkageAPI(), copyShrinkageData = _e[0], copyShrinkage = _e[1], clearCopyShrinkageData = _e[2];
    var _f = useClearShrinkageAPI(), clearShrinkageData = _f[0], clearShrinkage = _f[1], cleanClearShrinkageData = _f[2];
    var t = useTranslation('wizard').t;
    var queueData = useQueueAPI()[0];
    var queuesData = useQueuesAPI()[0];
    var queueId = useWizardParams().queueId;
    var _g = useState(false), copyDone = _g[0], setCopyDone = _g[1];
    var queueLocations = useEffectiveQueueLocations();
    var hasQueueLocations = queueLocations.length > 0;
    var capacityPermission = useEffectiveCapacityPermission();
    var isPlanLocked = useIsPlanLocked();
    var isDisabled = capacityPermission !== StatusPermission.Edit || isPlanLocked;
    var _h = useState((_b = (_a = queueLocations[0]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null), selectedQueueLocationId = _h[0], setSelectedQueueLocationId = _h[1];
    var disableCopyData = isDisabled || !selectedQueueLocationId;
    useEffect(function () {
        var _a, _b;
        setSelectedQueueLocationId((_b = (_a = queueLocations[0]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null);
        // Only reset when the active queue changes, not when queueLocations updates within the same queue
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queueId]);
    useEffect(function () {
        if (queueLocations.length === 0) {
            setSelectedQueueLocationId(null);
        }
        else if (!queueLocations.some(function (ql) { return ql.id === selectedQueueLocationId; })) {
            setSelectedQueueLocationId(queueLocations[0].id);
        }
    }, [queueLocations, selectedQueueLocationId]);
    var handleCopy = useCallback(function (_a) {
        var sourceQueueId = _a.sourceQueueId, sourceQueueLocationId = _a.sourceQueueLocationId;
        var doCopy = function () {
            return copyShrinkage({
                sourceQueueId: sourceQueueId,
                sourceQueueLocationId: sourceQueueLocationId,
                destQueueId: queueId,
                destQueueLocationId: selectedQueueLocationId,
            });
        };
        if (isDirty) {
            handleSaveWithoutValidation('submit', doCopy);
            return;
        }
        doCopy();
    }, [copyShrinkage, handleSaveWithoutValidation, isDirty, queueId, selectedQueueLocationId]);
    var handleLegacyCopy = useCallback(function (source) {
        var doCopy = function () {
            return copyShrinkage({
                sourceQueueId: Number(source),
                sourceQueueLocationId: null,
                destQueueId: queueId,
                destQueueLocationId: null,
            });
        };
        if (isDirty) {
            handleSaveWithoutValidation('submit', doCopy);
            return;
        }
        doCopy();
    }, [copyShrinkage, handleSaveWithoutValidation, isDirty, queueId]);
    var handleClear = useCallback(function () {
        var doClear = function () { return clearShrinkage(selectedQueueLocationId); };
        if (isDirty) {
            handleSaveWithoutValidation('submit', doClear);
            return;
        }
        doClear();
    }, [clearShrinkage, handleSaveWithoutValidation, isDirty, selectedQueueLocationId]);
    useEffect(function () {
        if (copyShrinkageData.data) {
            setCopyDone(true);
            refreshData();
        }
        else if (clearShrinkageData.data) {
            refreshData();
        }
        return function () {
            clearCopyShrinkageData();
            cleanClearShrinkageData();
        };
    }, [cleanClearShrinkageData, clearCopyShrinkageData, clearShrinkageData.data, copyShrinkageData.data, refreshData]);
    useEffect(function () {
        if (copyDone && !queueData.requesting && !queuesData.requesting) {
            setCopyDone(false);
            void trigger('shrinkages');
        }
    }, [copyDone, queueData.requesting, queuesData.requesting, trigger]);
    var otherQueues = useMemo(function () {
        var _a;
        var unassigned = getUnassignedLOB();
        return ((_a = queuesData.data) !== null && _a !== void 0 ? _a : [])
            .filter(function (q) { return q.id !== queueId; })
            .map(function (q) { return ({
            id: q.id,
            name: q.name,
            lobName: getLOBName(q.lobName, q.subLobName, unassigned),
        }); })
            .sort(function (a, b) { return sortByLOBName(a, b, unassigned); });
    }, [queuesData.data, queueId]);
    return (_jsx(StepContainer, __assign({ leftContent: _jsx(QueuePanel, {}) }, { children: _jsxs(StepPanel, { children: [_jsx(BasePanel, __assign({ onClear: handleClear, onCopy: hasQueueLocations ? undefined : handleLegacyCopy, disableCopy: hasQueueLocations, statusType: QueueStatusType.Shrinkages, errors: [copyShrinkageData.error, clearShrinkageData.error, queueData.error], requesting: !!copyShrinkageData.requesting || !!clearShrinkageData.requesting || !!queueData.requesting, title: t('shrinkage.shortName'), titleRightContent: hasQueueLocations ? (_jsx(Box, __assign({ minWidth: 200 }, { children: _jsx(ShrinkageLocationSelector, { selectedQueueLocationId: selectedQueueLocationId, setSelectedQueueLocationId: setSelectedQueueLocationId }) }))) : undefined, topRightContent: hasQueueLocations ? (_jsx(ShrinkageCopyFrom, { queues: otherQueues, onCopy: handleCopy, disabled: disableCopyData })) : undefined, rightContent: hasQueueLocations ? (_jsx(Link, __assign({ component: "button", type: "button", onClick: handleClear, disabled: disableCopyData, sx: { whiteSpace: 'nowrap' } }, { children: t('copyData.clearData') }))) : undefined }, { children: _jsx(ShrinkageContent, { queueLocationId: selectedQueueLocationId }) })), _jsx(AddShrinkageFactor, {})] }) })));
};
